import { CategoryFilter } from 'api/category-filter/types'
import { AdvertiserMock } from '../advertisers/data'
import { applications } from '../application/data'
import { ProductMock } from '../products/data'
import { publishers } from '../publisher/data'

export type CategoryFilterMock = Omit<
  CategoryFilter,
  'blockedAdvertisersConnection' | 'blockedProductsConnection'
> & {
  blockedAdvertisersConnection?: AdvertiserMock[]
  blockedProductsConnection?: ProductMock[]
}

export const categoryFilters: CategoryFilterMock[] = [
  {
    id: '1',
    applications: [applications[0]],
    placements: [],
    publisher: publishers[0],
    countryCodes: [], // worldwide
    blockedAdContents: ['dating'],
    blockedTasks: ['freeTrial'],
    blockedGenres: [],
    blockedComplexities: [1],
    createdAt: '2021-12-07T22:55:13Z',
    updatedAt: '2022-01-28T18:02:39Z',
    blockedAdvertisers: ['124'],
    blockedProducts: ['234112'],
    blockedAdvertisersConnection: [
      {
        id: '2',
        cmsId: '124',
        name: 'Voodoo',
        products: [
          {
            cmsId: '123490',
            id: '3',
            name: 'Tinder - Dating, Make Friends and Meet New People',
            advertiserCmsId: '124',
          },
          {
            cmsId: '314037',
            id: '4',
            name: 'FINAL FANTASY VII',
            advertiserCmsId: '124',
          },
        ],
      },
    ],
    blockedProductsConnection: [
      {
        cmsId: '234112',
        id: '5',
        name: 'MORTAL KOMBAT: The Ultimate Fighting Game!',
        advertiserCmsId: '125',
      },
    ],
  },
  {
    id: '2',
    applications: [applications[1]],
    placements: [],
    publisher: publishers[0],
    countryCodes: ['TR'],
    blockedAdContents: ['alcohol', 'dating'],
    blockedTasks: [],
    blockedGenres: [],
    blockedComplexities: [],
    createdAt: '2021-12-07T22:55:13Z',
    updatedAt: '2022-01-28T18:02:39Z',
    blockedAdvertisers: [],
    blockedProducts: [],
    blockedAdvertisersConnection: [],
    blockedProductsConnection: [],
  },
  {
    id: '3',
    applications: [applications[1]],
    placements: [],
    publisher: publishers[1],
    countryCodes: ['RO'],
    blockedAdContents: ['alcohol', 'dating'],
    blockedTasks: [],
    blockedGenres: [],
    blockedComplexities: [],
    createdAt: '2021-12-07T22:55:13Z',
    updatedAt: '2022-01-28T18:02:39Z',
    blockedAdvertisers: [],
    blockedProducts: [],
    blockedAdvertisersConnection: [],
    blockedProductsConnection: [],
  },
]
